var map = {
	"./buttons/grid-2-white.svg": 81232,
	"./buttons/grid-2.svg": 74880,
	"./buttons/paper-plane-top.svg": 62950,
	"./categories/cloud.png": 91531,
	"./categories/quality-engineering.png": 98257,
	"./categories/sogeti-delivery.png": 44444,
	"./globals/projects-selector.png": 50656,
	"./icons-pool/Employee_icon.png": 86761,
	"./icons-pool/Exclamation_icon.png": 97688,
	"./icons-pool/QA-dashboards.png": 66485,
	"./icons-pool/analysis-extension.png": 2047,
	"./icons-pool/analytics.png": 25201,
	"./icons-pool/artificial-intelligence.png": 25481,
	"./icons-pool/auto-spider.png": 46940,
	"./icons-pool/automation-framework-design-implementation.png": 59785,
	"./icons-pool/business-intelligence.png": 92179,
	"./icons-pool/business-usual.png": 26702,
	"./icons-pool/cognitiveqa.png": 32923,
	"./icons-pool/continuous-qa-devops-agile.png": 88036,
	"./icons-pool/data-info-governance.png": 3451,
	"./icons-pool/digital-happiness.png": 45173,
	"./icons-pool/digital.png": 64425,
	"./icons-pool/history-extension.png": 89289,
	"./icons-pool/iconExample.png": 6042,
	"./icons-pool/kcycle.png": 74054,
	"./icons-pool/kpis-extension.png": 32900,
	"./icons-pool/managed-specialized-testing.png": 42357,
	"./icons-pool/one-migrate.png": 15237,
	"./icons-pool/sandclock.png": 90601,
	"./icons-pool/software-analytics-office.png": 61788,
	"./icons-pool/tdm-service-virtualization.png": 76218,
	"./icons-pool/test-automation.png": 91977,
	"./icons-pool/test-design-execution.png": 69683,
	"./icons-pool/trends-leadin-solutions.png": 56987,
	"./placeholders/default-extension.png": 37745,
	"./placeholders/default-project.png": 47717,
	"./placeholders/default-service.png": 89651,
	"./placeholders/user.png": 97693,
	"./services/csp/csp-dashboard-extension.png": 70722,
	"./services/csp/csp-operations-extension.png": 81110,
	"./services/csp/csp-panel.png": 69444,
	"./services/csp/kpi/azureCsp.png": 86611,
	"./services/csp/kpi/costCsp.png": 98243,
	"./services/csp/kpi/licensesCsp.png": 82666,
	"./services/csp/kpi/subscriptionsCsp.png": 54246,
	"./services/csp/operations/cart-circle-check.svg": 80224,
	"./services/csp/operations/cart-circle-plus.svg": 45320,
	"./services/csp/operations/hourglass-clock.svg": 25847,
	"./services/deliveryexperience/bookmarks-extension.png": 85584,
	"./services/deliveryexperience/bookmarks/bookmarks.png": 98898,
	"./services/deliveryexperience/delivery-experience.png": 26438,
	"./services/deliveryexperience/docs-extension.png": 88670,
	"./services/deliveryexperience/docs/eml.png": 5769,
	"./services/deliveryexperience/docs/excel.png": 32418,
	"./services/deliveryexperience/docs/file.png": 74457,
	"./services/deliveryexperience/docs/gif.png": 2953,
	"./services/deliveryexperience/docs/jpg.png": 82670,
	"./services/deliveryexperience/docs/link.png": 58723,
	"./services/deliveryexperience/docs/mpp.png": 14966,
	"./services/deliveryexperience/docs/pdf.png": 24897,
	"./services/deliveryexperience/docs/png.png": 12374,
	"./services/deliveryexperience/docs/powerpoint.png": 59380,
	"./services/deliveryexperience/docs/txt.png": 53235,
	"./services/deliveryexperience/docs/word.png": 35787,
	"./services/deliveryexperience/docs/zip.png": 87070,
	"./services/deliveryexperience/dx-home.png": 14555,
	"./services/deliveryexperience/overview-extension.png": 7442,
	"./services/deliveryexperience/people-extension.png": 50706,
	"./services/deliveryexperience/people/user-helmet-safety.svg": 39391,
	"./services/deliveryexperience/requests-extension.png": 73673,
	"./services/deliveryexperience/timeline-extension.png": 12098,
	"./services/deliveryexperience/timeline/activity.png": 60136,
	"./services/deliveryexperience/timeline/billing.png": 45062,
	"./services/deliveryexperience/timeline/change.png": 78791,
	"./services/deliveryexperience/timeline/closing.png": 13754,
	"./services/deliveryexperience/timeline/consumption.png": 71098,
	"./services/deliveryexperience/timeline/csp_operation.png": 67419,
	"./services/deliveryexperience/timeline/events-not-occurred-grey.png": 87412,
	"./services/deliveryexperience/timeline/events-not-occurred.png": 22026,
	"./services/deliveryexperience/timeline/events-occurred.png": 78022,
	"./services/deliveryexperience/timeline/fired/activity-fired.png": 81332,
	"./services/deliveryexperience/timeline/fired/activity-fireoff.png": 89891,
	"./services/deliveryexperience/timeline/fired/agrupation-fired.png": 47795,
	"./services/deliveryexperience/timeline/fired/agrupation-fireoff.png": 94184,
	"./services/deliveryexperience/timeline/fired/change-fired.png": 54551,
	"./services/deliveryexperience/timeline/fired/change-fireoff.png": 1564,
	"./services/deliveryexperience/timeline/fired/closing-fired.png": 82652,
	"./services/deliveryexperience/timeline/fired/closing-fireoff.png": 53083,
	"./services/deliveryexperience/timeline/fired/consumption-fired.png": 37068,
	"./services/deliveryexperience/timeline/fired/consumption-fireoff.png": 97643,
	"./services/deliveryexperience/timeline/fired/follow-up-fired.png": 14122,
	"./services/deliveryexperience/timeline/fired/follow-up-fireoff.png": 63618,
	"./services/deliveryexperience/timeline/fired/issueerror-fired.png": 80526,
	"./services/deliveryexperience/timeline/fired/issueerror-fireoff.png": 12313,
	"./services/deliveryexperience/timeline/fired/issuewarning-fired.png": 30596,
	"./services/deliveryexperience/timeline/fired/issuewarning-fireoff.png": 38451,
	"./services/deliveryexperience/timeline/fired/kick-off-fired.png": 3997,
	"./services/deliveryexperience/timeline/fired/kick-off-fireoff.png": 81750,
	"./services/deliveryexperience/timeline/fired/milestone-fired.png": 29943,
	"./services/deliveryexperience/timeline/fired/milestone-fireoff.png": 21724,
	"./services/deliveryexperience/timeline/fired/newemployee-fired.png": 23351,
	"./services/deliveryexperience/timeline/fired/newemployee-fireoff.png": 9084,
	"./services/deliveryexperience/timeline/fired/proposal-resolution-fired.png": 41036,
	"./services/deliveryexperience/timeline/fired/proposal-resolution-fireoff.png": 39883,
	"./services/deliveryexperience/timeline/fired/qbr-fired.png": 80,
	"./services/deliveryexperience/timeline/fired/qbr-fireoff.png": 13327,
	"./services/deliveryexperience/timeline/fired/reload-fired.png": 41860,
	"./services/deliveryexperience/timeline/fired/reload-fireoff.png": 53875,
	"./services/deliveryexperience/timeline/fired/stage-fired.png": 89111,
	"./services/deliveryexperience/timeline/fired/unassignment-fired.png": 34977,
	"./services/deliveryexperience/timeline/fired/unassignment-fireoff.png": 38010,
	"./services/deliveryexperience/timeline/fired/virtual-visit-fired.png": 37350,
	"./services/deliveryexperience/timeline/fired/virtual-visit-fireoff.png": 50721,
	"./services/deliveryexperience/timeline/fired/workshop-training-fired.png": 3343,
	"./services/deliveryexperience/timeline/fired/workshop-training-fireoff.png": 94308,
	"./services/deliveryexperience/timeline/follow-up.png": 99240,
	"./services/deliveryexperience/timeline/issue-error.png": 92451,
	"./services/deliveryexperience/timeline/issue-warning.png": 69573,
	"./services/deliveryexperience/timeline/kick-off.png": 89781,
	"./services/deliveryexperience/timeline/milestone.png": 10081,
	"./services/deliveryexperience/timeline/new-incorporation.png": 56871,
	"./services/deliveryexperience/timeline/proposal-resolution.png": 43478,
	"./services/deliveryexperience/timeline/qbr.png": 24822,
	"./services/deliveryexperience/timeline/reload.png": 19232,
	"./services/deliveryexperience/timeline/request-csp.png": 31645,
	"./services/deliveryexperience/timeline/request-question.png": 49415,
	"./services/deliveryexperience/timeline/request-service-request.png": 22342,
	"./services/deliveryexperience/timeline/request-virtual-visit.png": 25032,
	"./services/deliveryexperience/timeline/stage-bright-purple.png": 17653,
	"./services/deliveryexperience/timeline/stage-green.png": 31351,
	"./services/deliveryexperience/timeline/stage-light-claret.png": 90398,
	"./services/deliveryexperience/timeline/stage-main-bg-color.png": 27833,
	"./services/deliveryexperience/timeline/stage-secondary-color.png": 62234,
	"./services/deliveryexperience/timeline/stage-tech-red.png": 57506,
	"./services/deliveryexperience/timeline/stage.png": 34965,
	"./services/deliveryexperience/timeline/timeline-carousel-grey.svg": 19351,
	"./services/deliveryexperience/timeline/timeline-carousel-white.svg": 38909,
	"./services/deliveryexperience/timeline/unassignment.png": 53041,
	"./services/deliveryexperience/timeline/virtual-visit.png": 72612,
	"./services/deliveryexperience/timeline/workshop-training.png": 21977,
	"./services/qualityeye/quality-eye.png": 38158,
	"./services/spiderlinkschecker/analysis-extension.png": 27028,
	"./services/spiderlinkschecker/spider-links-checker.png": 88407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;